import { render } from "./SelectInstructorsModal.vue?vue&type=template&id=4f066dfc&scoped=true"
import script from "./SelectInstructorsModal.vue?vue&type=script&lang=js"
export * from "./SelectInstructorsModal.vue?vue&type=script&lang=js"

import "./SelectInstructorsModal.vue?vue&type=style&index=0&id=4f066dfc&scoped=true&lang=css"
/* custom blocks */
import block0 from "./SelectInstructorsModal.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f066dfc"]])

export default __exports__